import NutritionFilterForm from "../NutritionFilterForm";
import AppMobileBottomNavContainer from "../AppMobileBottomNavContainer";

const NutritionFilterMobileNav = ({ isOpen, setIsOpen, type, categories }) => {
  return (
    <AppMobileBottomNavContainer isOpen={isOpen} setIsOpen={setIsOpen}>
      <NutritionFilterForm onClose={() => setIsOpen(false)} type={type} categories={categories} />
    </AppMobileBottomNavContainer>
  )
}

export default NutritionFilterMobileNav